import React, { FC, useEffect, useState } from 'react';
import { Input } from 'udesk-ui';

interface TemplateProps {
    value?: string;
    onChange?: (v?: string) => void;
    onBlur?: (v?: string) => void;
    readOnly?: boolean;
}

const Template: FC<TemplateProps> = (props) => {
    const { value, onChange, onBlur: _onBlur, readOnly } = props || {};

    const [innerValue, setInnerValue] = useState<string>();

    useEffect(() => {
        console.log(value);
        setInnerValue(value);
    }, [value]);

    const onInnerValueChange = (v?: string) => {
        setInnerValue(v);
        onChange?.(v);
    };

    const [isEditing, setIsEditing] = useState(false);

    const onFocus = () => {
        setIsEditing(true);
    };

    const onBlur = () => {
        setIsEditing(false);
        _onBlur?.(innerValue);
    };

    return (
        <Input.TextArea
            autoSize
            value={innerValue}
            onFocus={() => onFocus()}
            onBlur={() => onBlur()}
            onChange={(e) => onInnerValueChange(e.target.value)}
            readOnly={readOnly || !isEditing}
            bordered={!readOnly && isEditing}
        />
    );
};

export default Template;
